export default __webpack_public_path__ + "static/media/translating.8dd454df.webp";